export default {
  // Navegación
  nav: {
    home: "Inicio",
    contact: "Contacto",
    admin: "Administración",
    form: "Formulario",
  },

  // Encabezado
  header: {
    eventPeriod: "Del 5 de julio al 31 de agosto de 2025",
  },

  // Página de inicio
  home: {
    title: "Bienvenidos al Aeropuerto Toulouse-Blagnac",
    subtitle: "Tu puerta al mundo",
    description: "Descubre nuestros servicios e información para tu viaje",
    participate: "PARTICIPA AHORA",
    participateTitle: "INSCRÍBETE",
    itsVerySimple: "Y GANA",
    fillCoordinates: "Rellena tus datos",
    discoverGift: "Descubre tu regalo",
    retrieveGift: "Recoge tu regalo o aprovecha tu oferta en una de las tiendas del aeropuerto",
    gameWinning: "¡JUEGO 100% GANADOR!",
    toWin: "A GANAR",
    travel: "un viaje",
    wirelessHeadphones: "auriculares inalámbricos",
    vouchersAndGifts: "vales de compra y muchos otros regalos",
    participationSimple: "PARA PARTICIPAR ES MUY FÁCIL,",
    gifts: "REGALOS!",
  },

  // Formulario
  form: {
    loading: "Cargando...",
    title: "Formulario de reserva",
    submit: "Enviar",
    cancel: "Cancelar",
    required: "Este campo es obligatorio",
    email: "Correo electrónico",
    name: "Nombre completo",
    phone: "Teléfono",
    message: "Mensaje",
    fillForm: "INGRESA TU CORREO ELECTRÓNICO",
    discoverGain: "PARA DESCUBRIR TU PREMIO",
    pleaseWait: "Por favor, espera",
    requiredFields: "*Campo obligatorio",
    privacyNotice:
      "Los datos personales proporcionados por los participantes se procesan electrónicamente con el fin de gestionar el juego y están destinados al Aeropuerto Toulouse-Blagnac. De acuerdo con la Ley francesa 'Informatique et Libertés' del 6 de enero de 1978, modificada en 2004, y con el Reglamento General de Protección de Datos (RGPD), tienes derecho a acceder, rectificar, eliminar y transferir tus datos, así como a oponerte o limitar su tratamiento.",
    invalidEmail:
      "Tu correo es temporal, contiene un + o es inválido.",
  },

  // Contacto
  contact: {
    title: "Contáctanos",
    address: "Dirección",
    phone: "Teléfono",
    email: "Correo electrónico",
    sendMessage: "Enviar mensaje",
    pageTitle: "CONTÁCTANOS",
    lastName: "Tu apellido*",
    firstName: "Tu nombre*",
    emailAddress: "Tu dirección de correo electrónico*",
    requestType: "Tipo de solicitud*",
    subject: "Asunto*",
    message: "Mensaje*",
    chooseOption: "Elige una opción",
    technicalIssue: "Problema técnico durante mi participación",
    siteNotWorking: "El sitio web del juego no funciona",
    gameInfo: "Solicitud de información sobre el juego",
    other: "Otro",
    requiredFields: "*Campos obligatorios",
    send: "ENVIAR",
    loading: "Cargando...",
    fieldRequired: "Este campo es obligatorio",
  },

  // Administración
  admin: {
    title: "Administración",
    dashboard: "Panel de control",
    users: "Usuarios",
    settings: "Configuraciones",
    fillForm: "RELLENA EL FORMULARIO",
    discoverGain: "PARA DESCUBRIR TU REGALO",
    pleaseWait: "Por favor, espera",
    ticketAddedSuccess: "¡TICKET DE COMPRA AÑADIDO CON ÉXITO!",
    clickToAddAnother:
      "Haz clic en el botón de abajo para añadir otro ticket",
    requiredFields: "*Campo obligatorio",
    privacyNotice:
      "Los datos personales facilitados por los participantes serán tratados informáticamente para la gestión del juego y están destinados a Aéroport Toulouse-Blagnac. De acuerdo con la ley de 'informática y libertades' del 6 de enero de 1978, modificada en 2004, y el Reglamento General de Protección de Datos (RGPD), usted tiene derecho a acceder, rectificar, suprimir y portar los datos recogidos, así como a oponerse a su tratamiento o limitarlo.",
    uniqueCode: "Código único",
    invalidCode: "Código inválido o ya utilizado",
    verify: "VERIFICAR",
    errorOccurred: "Ha ocurrido un error, por favor inténtalo de nuevo.",
    pleaseEnterCode: "Por favor, introduce un código",
    invalidEmailMessage: "Tu correo es temporal, contiene un + o es inválido.",
  },

  // Mensajes generales
  common: {
    loading: "Cargando...",
    error: "Ha ocurrido un error",
    success: "Operación exitosa",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    save: "Guardar",
    close: "Cerrar",
    back: "volver",
  },

  // Juego Terminado
  gameover: {
    title: "Juego Terminado",
    subtitle: "¡Gracias por participar!",
    thanksMessage: "Esperamos que hayas disfrutado de esta experiencia.",
    comeBackMessage: "¡Vuelve pronto para nuevas oportunidades de ganar premios!",
    backToHome: "Volver al Inicio",
    contactUs: "Contáctanos",
    eventPeriod: "Evento del 5 de julio al 31 de agosto de 2025",
  },

  // Pie de página
  footer: {
    rules: "Reglamento",
    legalNotice: "Aviso legal",
    privacyPolicy: "Política de privacidad",
    cookies: "Cookies",
    contactUs: "Contáctanos",
    slogan: "Shopping & Service: ¡Vibra, Comparte, vive Toulouse!",
  },

  // Premios y recompensas
  lots: {
    congratulations: "¡BRAVO!",
    youWin: "HAS GANADO",
    voucher5: "UN VALE DE 5 € TTC",
    voucher15: "UN VALE DE 15 € TTC",
    voucherCondition: "válido por una compra mínima de 20 € TTC excepto tabaco y alcohol en tiendas Relay restaurantes de la terminal",
    voucher15Condition: "válido por una compra mínima de 50 € TTC excepto tabaco y alcohol en cualquier tienda de la terminal",
    howToBenefit: "¿CÓMO RECLAMAR TU PREMIO?",
    findConfirmation: "<b class=\"not-italic\">ENCUENTRA</b> la confirmación de tu premio en el correo enviado a la dirección que proporcionaste al registrarte.",
    findConfirmationVoyage: "<b class=\"not-italic\">REVISA</b> tu bandeja de entrada: se enviará un mensaje a la dirección de correo que proporcionaste al registrarte. ¡No olvides revisar tu carpeta de spam!",
    goToShop: "<b class=\"not-italic\">ACUDE </b> a una de las tiendas Relay o a uno de los restaurantes de la terminal y realiza tus compras",
    goToShop2: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans l’un(e) des boutiques et restaurants de l’aérogare",
    goToShopAirpods: "<b class=\"not-italic\">ACUDE </b> a tu tienda Relay / Stade Toulousain / Fnac en la terminal, donde un empleado te entregará tu premio tras mostrar el correo de confirmación.",
    goToShopPanier: "<b class=\"not-italic\">ACUDE </b> a tu tienda Relay / Stade Toulousain / Fnac en la terminal, donde un empleado te entregará tu premio tras mostrar el correo de confirmación.",
    goToShopGeneral: "<b class=\"not-italic\">ACUDE </b> a una de las tiendas de la terminal",
    goToShopBr15: "<b class=\"not-italic\">VE</b> a una de las tiendas de la terminal y realiza tus compras",
    sendCoordinates: "<b class=\"not-italic\">ENVÍANOS</b> tus datos de contacto (nombre, apellidos y número de teléfono), y nos pondremos en contacto contigo",
    enjoyGift: "<b class=\"not-italic\">DISFRUTA</b> de tu regalo",
    enjoyGift2: "<b class=\"not-italic\">DISFRUTA</b> de tu vale mostrando tu correo de confirmación en la caja",
    enjoyGiftExclamation: "<b class=\"not-italic\">DISFRUTA</b> de tu regalo!",
    enjoyGiftExclamation2: "<b class=\"not-italic\">DISFRUTA</b> de tu vale mostrando tu correo de confirmación en la caja",
    enjoyVoucher: "<b class=\"not-italic\">DISFRUTA</b> de tu vale de compra mostrando tu correo electrónico de confirmación en la caja",
    enjoyTrip: "<b class=\"not-italic\">DISFRUTA</b> de tu estancia",
    enjoyVoucherBr15: "<b class=\"not-italic\">DISFRUTA</b> de tu vale de compra mostrando tu correo electrónico de confirmación en la caja",
    warning: "Importante: tu premio es válido solo hoy hasta las 23:59. Pasado ese horario, se considerará perdido y volverá a estar en juego.",
    
    // Nombres de premios
    planeTickets: "BILLETES DE AVIÓN*",
    fan: "¡UN ABANICO!",
    wirelessHeadphones: "AURICULARES<br>INALÁMBRICOS JBL <br>TUNE FLEX",
    giftBasket: "UNA CESTA<br>DE REGALOS",
    beachBall: "¡UNA PELOTA DE<br>PLAYA!",
    
    // Texto para condiciones especiales
    seeRules: "*Consulta el reglamento oficial para más detalles",
    giftBasketOrigin: "de las tiendas del<br>aeropuerto Toulouse-Blagnac",
  },

  // Página de fin de juego
  perd: {
    sorry: "LO SENTIMOS",
    gameOver: "EL JUEGO HA TERMINADO",
    thanksForParticipating: "¡Gracias por participar!",
  },
}